import { Button, styled, Typography } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router';
import { DEFAULT_LANDING_PAGE } from '../../../../constants';
import {
  useAuthenticationServiceContext,
  useNullableDomainContext,
} from '../../../../context/contexts';
import { Error } from './Error';

const StyledButton = styled(Button)`
  margin: 5px;
  background-color: #00a599;
  &:hover {
    background-color: rgba(27, 113, 107);
  }
`;

const RestrictedDashboardErrorComponent = () => {
  const history = useHistory();
  const authService = useAuthenticationServiceContext();
  const domain = useNullableDomainContext();

  const goBack = () => {
    // If there's no history to go back to (e.g., first page after login),
    // navigate to the default landing page
    if (history.length <= 2) {
      history.push(DEFAULT_LANDING_PAGE);
    } else {
      history.goBack();
    }
  };

  const logOut = () => {
    localStorage.clear();
    void authService.logOutUser(domain);
  };

  return (
    <Error
      title={{ key: 'pages:errorBoundary.restrictedDashboard' }}
      message={() => (
        <Typography variant="h5">
          <Trans
            i18nKey="pages:errorBoundary.restrictedDashboardExplanation"
            components={[<br />]}
          />
        </Typography>
      )}
      exit={(t: TFunction) => (
        <>
          <StyledButton variant="contained" color="primary" onClick={goBack}>
            {t('common:buttonsAndMenus.back')}
          </StyledButton>
          <StyledButton variant="contained" color="primary" onClick={logOut}>
            {t('common:shell.account.logout')}
          </StyledButton>
        </>
      )}
    />
  );
};

export default RestrictedDashboardErrorComponent;
